<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-container lg">
      <div class="button close">
        <span role="button" class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </span>
      </div>
      <div class="popup">

        <div class="popup-title">
          <span class="hdg02 mb20">{{ group1.book_title }}</span>
          <span class="hdg04">{{ group1.author }}</span>
        </div>
        <div class="popup-content">
          <p class="txt mb48">
            <!-- QAタイトル1行目 -->
            <span v-html="group1.qa_title_first_line"></span><br>
            <!-- QAタイトル2行目以降 -->
            <template v-for="(line, index) in group1.qa_title_after_second_lines">
              <span :key="'second_line_' + index" class="indent">{{ line }}<br></span>
            </template>
          </p>
          <p v-if="group1.manual_recomentation == 0" class="txt">{{ group1.book_publication_date }}発行</p>
          <p v-else class="txt">追録第{{ group1.manual_recomentation || ' - ' }}号（{{ group1.book_publication_date }}発行）</p>
        </div>

      </div>
    </div>
    <iframe style="border: none; position: absolute; top: 0; left: 0; height: 100%; width: 100%; z-index: -1;" src="about:blank"></iframe>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'
import * as logicQAAboutBook from '@/logic/qa/QAAboutBook'

export default defineComponent({
  props: {
    parentGroup1: {
      type: Object,
      required: true
    }
  },
  setup (props, context) {

    const group1 = logicQAAboutBook.getGroup(props, context)

    const close = () => {
      context.emit('closeAboutBook')
    }
   
    return {
      group1,
      close
    }
  }
})
</script>

<style lang="scss" scoped>
.popup {
  &-title {
    [class*="hdg"] {
      display: block;
    }
  }
  &-content {
    .txt {
      font-size: 1.8rem;
    }
  }
}
.popup-content {
  min-height: 560px;
}
</style>
